var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlbum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20.701,
    viewBox: "0 0 24 20.701",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_884",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 884",
    transform: "translate(-12 -16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_666",
    "data-name": "\\u30D1\\u30B9 666",
    d: "M23.365,11.32H2.88a1.644,1.644,0,0,0-1.755,1.49v9.845a1.644,1.644,0,0,0,1.755,1.49H23.37a1.644,1.644,0,0,0,1.755-1.49V12.81A1.652,1.652,0,0,0,23.365,11.32Z",
    transform: "translate(10.875 12.555)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_667",
    "data-name": "\\u30D1\\u30B9 667",
    d: "M21.114,9.352H5.129c-.346,0-.629-.443-.629-.984h0c0-.541.283-.984.629-.984H21.114c.346,0,.629.443.629.984h0C21.743,8.909,21.46,9.352,21.114,9.352Z",
    transform: "translate(10.875 11.942)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_668",
    "data-name": "\\u30D1\\u30B9 668",
    d: "M18.983,5.414H7.26c-.279,0-.51-.408-.51-.9V4.345c0-.492.231-.9.51-.9H18.983c.279,0,.51.408.51.9v.169C19.493,5.006,19.262,5.414,18.983,5.414Z",
    transform: "translate(10.875 12.555)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlbum);
export default __webpack_public_path__ + "static/media/album.843745b069e2b13dde8f31039b9934cd.svg";
export { ForwardRef as ReactComponent };